module.exports = __webpack_public_path__ + "img/Restore.f72abf99.svg";